import { render } from "./LocationMessage.vue?vue&type=template&id=64f96f7d&scoped=true"
import script from "./LocationMessage.vue?vue&type=script&lang=js"
export * from "./LocationMessage.vue?vue&type=script&lang=js"

import "./LocationMessage.vue?vue&type=style&index=0&id=64f96f7d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f96f7d"]])

export default __exports__